var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('main',{staticClass:"s-main-bg"},[_c('Navbar'),_c('div',{staticClass:"s-ht-100-vh s-keep-view"},[_c('router-view')],1),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }